import {
  LOGIN,
  LOGOUT,
  UPDATE_ACCESS_TOKEN,
  UPDATE_IS_REFRESHING_TOKEN
} from "../types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...action.user
      };
    case LOGOUT:
      return { ...initialState };
    case UPDATE_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken,
        expiry: action.expiry,
        sessionId: action.sessionId
      };
    case UPDATE_IS_REFRESHING_TOKEN:
      return {
        ...state,
        isRefreshing: action.isRefreshing
      };
    default:
      return state;
  }
};
